import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

export interface ISubpageRenderProps {
  index: number;
  total: number;
  currentRouteIsValid: boolean;
  handlePrev: () => void;
  handleNext: () => void;
}

interface SubViewRoute {
  Component: React.SFC;
  path: number;
  validator?: any;
  props?: any;
  render: (props: ISubpageRenderProps) => any;
}

interface IProps {
  match: any;
  subViewRoutes: Array<SubViewRoute>;
  onComplete: (value: any) => void;
  onProgress?: (index: number, total: number) => void;
}

const getCurrentRouteByPath = (routes, match, path, locale) =>
  routes.find(route => `${match.path}/${route.path}` === path);

@inject('routing', 'dataStore')
@observer
export default class SubPageController extends React.Component<
  RouteComponentProps<any> & IProps & any
> {
  public state = {};
  private routeIndex = 0;

  constructor(props) {
    super(props);
    props.routing.history.subscribe((location, action) => {
      if (action === 'POP') {
        this.setRouteIndex();
        this.props.dataStore.setCurrentRouteIsValid(
          this.isValid(this.props.subViewRoutes[this.routeIndex])
        );
      }
    });
    this.setRouteIndex();
  }

  public render() {
    const { match, subViewRoutes, routing, dataStore } = this.props;
    const { location } = routing;

    let currentRoute = getCurrentRouteByPath(
      subViewRoutes,
      match,
      location.pathname,
      dataStore.locale
    );

    if (!currentRoute) {
      currentRoute = subViewRoutes[0];
    }

    this.routeIndex = this.getIndex(subViewRoutes, currentRoute);

    const currentRouteIsValid =
      typeof currentRoute.validator !== 'function' ||
      dataStore.currentRouteIsValid;
    return (
      <React.Fragment>
        <Switch>
          {subViewRoutes.map(route => (
            <Route
              key={route.path}
              path={`${match.path}/${route.path}`}
              render={() => {
                return (
                  <route.Component
                    {...route.props}
                    onForceNext={() => this.handleNext()}
                  />
                );
              }}
              exact
            />
          ))}
          <Redirect to={`${match.path}/${subViewRoutes[0].path}`} />
        </Switch>
        {this.props.render({
          index: this.routeIndex,
          total: subViewRoutes.length,
          currentRouteIsValid,
          handlePrev: this.handlePrevious.bind(this),
          handleNext: this.handleNext.bind(this)
        })}
      </React.Fragment>
    );
  }

  private setRouteIndex() {
    const { match, subViewRoutes, routing, dataStore } = this.props;
    const { location } = routing;

    const currentRoute = getCurrentRouteByPath(
      subViewRoutes,
      match,
      location.pathname,
      dataStore.locale
    );

    this.routeIndex = this.getIndex(subViewRoutes, currentRoute);
  }

  private getIndex(subViewRoutes, currentRoute) {
    let index = subViewRoutes.indexOf(currentRoute);
    if (index === -1) {
      index = 0;
    }
    return index;
  }

  private handlePrevious() {
    if (this.routeIndex > 0) {
      const { dataStore, subViewRoutes } = this.props;
      this.routeIndex--;
      dataStore.setCurrentRouteIsValid(
        this.isValid(subViewRoutes[this.routeIndex])
      );
      this.gotoRouteByIndex(this.routeIndex);
    }
  }
  private handleNext() {
    const { dataStore, subViewRoutes } = this.props;

    if (this.isValid(subViewRoutes[this.routeIndex])) {
      if (this.routeIndex < subViewRoutes.length - 1) {
        this.routeIndex++;
        dataStore.setCurrentRouteIsValid(
          this.isValid(subViewRoutes[this.routeIndex])
        );
        this.gotoRouteByIndex(this.routeIndex);
      } else {
        this.props.onComplete();
      }
    }
  }

  private isValid(route) {
    return typeof route.validator !== 'function' || route.validator();
  }

  private gotoRouteByIndex(index: number) {
    const route = this.props.subViewRoutes[index];
    const {
      match,
      routing: { push }
    } = this.props;

    push(`${match.path}/${route.path}`);
  }
}



// WEBPACK FOOTER //
// ./src/containers/components/SubPageController.tsx